import React from "react";
import { AppStatusSectionConfigs } from "./AppStatusSectionConfigs";

const DynamicSections = ({selectedStatus,register,errors,control,lookupdata,resetFields}) => {
    if(!selectedStatus) return null;

    return(
        <>
            {AppStatusSectionConfigs.map(({key,component: Component}) => {
                if(selectedStatus[key]){
                    return <Component key={key} register={register} errors={errors} control={control} lookupdata={lookupdata} resetField={resetFields}/>;
                }
                return null;
            })}
        </>
    )
}

export default DynamicSections;